import React from 'react';
import { Button } from '../ui/button';
import { CriticalStockProduct } from '../../lib/types';

interface CriticalStockProductsTableProps {
  data: CriticalStockProduct[];
  onSeeAll: () => void;
  className?: string;
}

export function CriticalStockProductsTable({ data, onSeeAll, className = '' }: CriticalStockProductsTableProps) {
  const displayData = data.slice(0, 10);

  return (
    <div className={`bg-white p-6 rounded-lg shadow ${className}`}>
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Products with Critical Stock</h3>
        <Button variant="outline" size="sm" onClick={onSeeAll}>
          See All
        </Button>
      </div>
      <p className="text-sm text-gray-600 mb-4">{data.length} Products</p>
      
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 font-medium text-gray-900">Product Name</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">No. Of Machines with Critical</th>
            </tr>
          </thead>
          <tbody>
            {displayData.map((product) => (
              <tr key={product.productId} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-4 text-sm font-medium text-gray-900">{product.productName}</td>
                <td className="py-3 px-4 text-sm text-right">
                  <span className={`font-medium ${
                    product.machinesWithCritical > 5 ? 'text-red-600' : 
                    product.machinesWithCritical > 2 ? 'text-yellow-600' : 'text-green-600'
                  }`}>
                    {product.machinesWithCritical}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
